var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction",style:({ backgroundImage: ("url(" + (_vm.item.img) + ")")})},[_c('div',{staticClass:"contain"},[_c('div',{staticClass:"show",on:{"click":function($event){return _vm.go(_vm.item.link)}}}),_c('ai1')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }